module.exports = __webpack_public_path__ + "static/media/self.cf764548.png";